import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { faFacebook, faTwitter, faLinkedin, faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './BikeDetails.css';

function BikeDetails() {
  const { id } = useParams();
  const [bike, setBike] = useState(null);

  useEffect(() => {
    console.log('Fetching bike with ID:', id);
    axios.get(`https://cardealer-backend-shac.onrender.com/api/bikes/${id}`)
      .then(response => setBike(response.data))
      .catch(error => console.error('Error fetching bike details:', error));
  }, [id]);

  if (!bike) {
    return <div>Loading...</div>;
  }

  const createShareLinks = () => {
    const url = window.location.href;
    const text = `Check out this ${bike.brand} ${bike.model} for Ksh${bike.price}!`;
    const encodedText = encodeURIComponent(text);

    return {
      whatsapp: `https://wa.me/?text=${encodedText} ${url}`,
    };
  };
  const handleWhatsAppChat = () => {
    // Replace with the actual phone number (e.g., "1234567890" for a US number)
    const phoneNumber = "+254792454764"; // Target WhatsApp number
    const message = `Hello, I would like to enquire about this bike: ${bike.brand}, ${bike.model}.`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, '_blank'); // Open in a new tab
};


  const shareLinks = createShareLinks();


  return (
    <div className="bike-details-container">
      <h2>{bike.brand} {bike.model}</h2>
      <img src={bike.imageUrl} alt={`${bike.brand} ${bike.model}`} className="bike-image" />
      <div className="bike-info">
        <p><strong>Price:</strong> Ksh{bike.price}</p>
        <p><strong>Year:</strong> {bike.year}</p>
        <p><strong>Color:</strong> {bike.color}</p>
        <p><strong>Mileage:</strong> {bike.mileage} km</p>
        <p><strong>Condition:</strong> {bike.condition}</p>
        <p><strong>Current Location:</strong> {bike.currentLocation}</p>
        <p><strong>Availability:</strong> {bike.availability ? 'Available' : 'Not Available'}</p>
        <p><strong>Tire Size:</strong> {bike.tireSize}</p>
        <p><strong>Description:</strong> {bike.description}</p>
      </div>


        <div>
            <button className="action-button" onClick={handleWhatsAppChat}>
                Enquire via WhatsApp
            </button>
        </div>
      <div className="share-buttons">
        <h3>Share this bike:</h3>
                  {/* Social Media Share Buttons */}
                  <div className="social-share">
            <h4>Share this car:</h4>
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`} target="_blank" rel="noopener noreferrer" className="social-icon facebook">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href={`https://twitter.com/intent/tweet?url=${window.location.href}`} target="_blank" rel="noopener noreferrer" className="social-icon twitter">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href={`https://www.linkedin.com/shareArticle?url=${window.location.href}`} target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a href={`https://api.whatsapp.com/send?text=${window.location.href}`} target="_blank" rel="noopener noreferrer" className="social-icon whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
            <a href="https://www.instagram.com/your_profile" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
      </div>
    </div>
  );
}

export default BikeDetails;
